// Port of ErrorScreen() in android/.../ui/MainActivity.kt.
// Two flavors:
//   noInternet=true  → "No internet connection" + Wi-Fi hint (no raw message)
//   noInternet=false → "Cannot reach server" + raw message in small muted text
// The Retry button calls fetchContent() — same handler the Android version
// wires to its onRetry lambda.

import { DISCONNECT_CODES } from '../lib/disconnectCodes'
import DisconnectCode from './DisconnectCode'

interface Props {
  message:    string
  noInternet: boolean
  onRetry:    () => void
}

export default function ErrorScreen({ message, noInternet, onRetry }: Props) {
  void message
  const title  = noInternet ? 'No internet connection' : 'Cannot reach server'
  const detail = noInternet
    ? 'Make sure the device is connected to Wi-Fi.'
    : 'Check that the WeTook server is reachable from this device.'
  const code = noInternet ? DISCONNECT_CODES.NO_INTERNET : DISCONNECT_CODES.SERVER_UNREACHABLE

  return (
    <div className="flex w-full max-w-md flex-col items-center gap-3 px-5 text-center sm:px-10">
      <h2 className="text-white text-[clamp(1.1rem,5.5vw,1.25rem)] font-semibold">{title}</h2>
      <p className="text-muted text-[13px] leading-relaxed">{detail}</p>
      <DisconnectCode code={code} />
      <button
        type="button"
        onClick={onRetry}
        className="mt-2 min-h-10 px-5 py-2 rounded-md bg-brand text-white text-sm font-semibold hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand"
      >
        Retry
      </button>
    </div>
  )
}
